export default "__VITE_ASSET__YCj6M9Ec__"